import { ComponentType, PropsWithChildren, SVGProps } from "react";

export type IconComponent = ComponentType<BaseIconProps>;

type SizelessSVGProps = Omit<SVGProps<SVGSVGElement>, "width" | "height">;

export type BaseIconProps = PropsWithChildren<SizelessSVGProps> & {
  size?: number | string;
};

export function BaseIcon({ children, className, size = 32, ...props }: BaseIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      role="img"
      {...props}
    >
      {children}
    </svg>
  );
}
